<template>
  <Page>
    <div class="topimg"></div>
    <div class="con">
      <div class="tab-box">
        <div class="tab" :class="{hover:tabCheIndex===0}" @click="changeTab(0)">
          <span class="hover-bg"></span>
          <h2 class="fs20">{{$t('t1')}}</h2>
          <h4 class="fs16 mt10" v-if="lang==='zh'">相关新闻</h4>
        </div>
        <div class="tab" :class="{hover:tabCheIndex===1}" @click="changeTab(1)">
          <span class="hover-bg"></span>
          <h2 class="fs20">{{$t('t2')}}</h2>
          <h4 class="fs16 mt10" v-if="lang==='zh'">相关新闻</h4>
        </div>
        <router-link class="tab" to="/dynamic/media">
          <span class="hover-bg"></span>
          <h2 class="fs20">{{$t('t3')}}</h2>
          <h4 class="fs16 mt10" v-if="lang==='zh'">相关新闻</h4>
        </router-link>
      </div>

      <List :list='newslist' v-if="tabCheIndex===0"></List>
      <List :list='newslist2' v-if="tabCheIndex===1"></List>

    </div>
  </Page>
</template>

<script>
import Page  from '@/components/page.vue'
import List  from '@/components/List/news-list.vue'

export default {
  name: '',
  components:{Page,List},
  data(){
    return {
      tabCheIndex:0,
      // newslist
    }
  },
  i18n:{
    messages:{
      zh:{
        t1:'陶瓷产品展',
        t2:'陶瓷装备与材料展',
        t3:'最新动态',
        t4:'相关新闻'
      },
      en:{
        t1:'Products Expo',
        t2:'Technology Expo',
        t3:'Press Releases',
        t4:'相关新闻'
      }
    }
  },
  created(){
    console.log(this.$store);
    this.newslist.length==0&&this.$store.dispatch('dynamic/getNewsList');
    this.newslist.length==0&&this.$store.dispatch('dynamic/getNewsList2');
  },
  computed:{
    newslist(){return this.$store.state.dynamic.newslist},
    newslist2(){return this.$store.state.dynamic.newslist2},
    lang(){return this.$store.state.index.lang}
  },
  methods:{
    changeTab(idx){
      this.tabCheIndex=idx;
    }
  }
}
</script>

<style scoped>
.topimg{width:100%; height:9.42vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:100% 100%;}

.con{padding:4.47vw 5.26vw;}

.tab-box{display:flex;}
.tab{box-sizing: border-box; min-width:10.842vw; /*height:4.4737vw;*/ padding:0.8vw 1vw 0.8vw 1.3vw; /*padding-left:1.3vw; padding-right:1vw;*/ color:#4a4a4a; border:1px solid #4a4a4a; margin-right:0.789vw; position:relative;  transition:300ms; cursor:pointer;}
.tab>h2{position: relative;}
.tab>h4{position: relative; font-weight: normal;}
.tab .hover-bg{position: absolute;top: 0;right: 0;height: 100%;width: 100%; background:#fff; transition: all 300ms ease-in-out;}
.tab.hover{color:#fff; border:1px solid #f50045;}
.tab.hover .hover-bg{left:0; right:auto; width:100%; background:#f50045;}
.list{margin-top:2.36vw;}


@media (max-width:991px){
.fs16{font-size:2.8vw; line-height:2.8vw;}
.fs20{line-height:4.4vw;}
.topimg{width:100%; height:20vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:cover;}
.con{padding:6vw 1.5vw;}

.tab{width:37.4vw; height:13.4vw; padding-left:3vw; margin-right:2vw; }
.tab>h4{display:none;}
.list{margin-top:4vw;}
}
</style>


